import { render } from "./DrinkInfo.vue?vue&type=template&id=72a271cd&scoped=true"
import script from "./DrinkInfo.vue?vue&type=script&lang=js"
export * from "./DrinkInfo.vue?vue&type=script&lang=js"

import "./DrinkInfo.vue?vue&type=style&index=0&id=72a271cd&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-72a271cd"

export default script